import primary from "./primary";

export default primary;
